<template>
  <div class="o-answers">
    <div class="o-answers__header">
      <h2>{{ $t('wrongAnswers.title') }}</h2>
      <p>{{ $t('wrongAnswers.description') }}</p>
      <input
        v-if="answers.length"
        v-model="query"
        class="o-input o-search"
        type="search"
        placeholder="Zoek op antwoord"
      />
    </div>

    <div v-if="answers.length" ref="list" class="o-answers__list" @touchmove.stop>
      <div
        v-for="(answer, index) in filteredAnswers"
        :key="`${index}-${answer.guess}-${answer.name}-${answer.guessed_at}`"
        class="o-answers__answer"
      >
        <span class="o-answers__answer__dot" />
        <div class="o-answers__answer__content">
          <strong>{{ answer.guess }}</strong>
          <div class="o-answers__answer__meta">
            {{ formatDate(answer.guessed_at) }}
            door
            {{ answer.name }}
            uit
            {{ answer.place }}
          </div>
        </div>
      </div>
    </div>

    <div v-else class="o-answers__empty">
      <p>Nog geen antwoorden ontvangen.</p>
    </div>

    <div v-if="false && answers.length" class="o-answers__chin">
      <p>{{ filteredAnswers.length }} {{ filteredAnswers.length === 1 ? 'antwoord' : 'antwoorden' }}</p>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'pinia'
import { useSignupStore } from '../store/signup'
import { dataLayer } from '@dpgradio/creative'
import { debounce } from '../utils/debounce'

const dateFormatter = new Intl.DateTimeFormat('nl-NL', {
  weekday: 'short',
  day: 'numeric',
  month: 'short',
  hour: 'numeric',
  minute: 'numeric',
})

export default {
  name: 'WrongAnswers',
  data() {
    return {
      query: '',
    }
  },
  computed: {
    ...mapState(useSignupStore, ['answers']),
    filteredAnswers() {
      return this.answers.filter((answer) => {
        return answer.guess.toLowerCase().includes(this.query.toLowerCase())
      })
    },
  },
  watch: {
    query(newQuery) {
      this.debouncedTrackQuery(newQuery)
    },
  },
  mounted() {
    this.fetchAnswers()
    this.debouncedTrackQuery = debounce((query) => {
      dataLayer.pushCampaignAction('wrong_answers_search', { query })
    }, 1000)
  },
  methods: {
    ...mapActions(useSignupStore, ['fetchAnswers']),
    formatDate(rawDate) {
      return dateFormatter.format(new Date(rawDate))
    },
  },
}
</script>

<style lang="scss">
.o-answers {
  background-color: white;
  color: white;
  height: 100%;
  display: grid;
  grid-template-rows: auto 1fr auto;
  grid-template-areas:
    'header'
    'list'
    'chin';
  position: relative;
  overflow: hidden;
  touch-action: pan-y;
  &__header {
    grid-area: header;
    padding: 20px;
    position: sticky;
    top: 0;
    background-color: rgb(var(--secondary-color));
    z-index: 10;

    h2 {
      margin: 0 0 10px 0;
      color: white;
    }

    p {
      margin: 0 0 10px 0;
    }
  }

  &__list {
    grid-area: list;
    padding: 10px 20px;
    background: white;
    overflow-y: auto;
    -webkit-overflow-scrolling: touch;
    overscroll-behavior: contain;
    position: relative;
    min-height: 0;
    contain: layout style;

    // Add a fade so even boomers can discover the scroll
    mask-image: linear-gradient(to bottom, black 70%, transparent);
    -webkit-mask-image: linear-gradient(to bottom, black 70%, transparent);
  }

  &__empty {
    grid-area: list;
    padding: 40px 20px;
    background: white;
    color: rgb(var(--secondary-color));
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;

    p {
      margin: 0;
      font-size: 1.1rem;
      opacity: 0.7;
    }
  }

  &__chin {
    grid-area: chin;
    padding: 10px 20px;
    background-color: rgb(var(--secondary-color));
    text-align: center;
    font-size: 0.9rem;
    position: sticky;
    bottom: 0;
    z-index: 10;

    p {
      margin: 0;
    }
  }

  &__answer {
    background: white;
    color: rgb(var(--secondary-color));
    padding: 10px;
    margin-bottom: 10px;
    display: flex;

    &__dot {
      display: inline-block;
      width: 10px;
      height: 10px;
      border-radius: 999999px;
      background: rgb(var(--primary-color));
      margin-right: 18px;
      margin-top: 6px;
    }

    &__content {
      flex: 1;
      font-family: var(--font-body);
    }

    &__meta {
      margin-top: 4px;
      color: #aeaeae;
      font-size: 0.8rem;
    }
  }
}

.o-input {
  display: block;
  width: 100%;
  font-family: var(--font-body);
  font-size: 16px;
  padding: 12px;
  padding-left: 12px;
  border: 0;
  outline: 2px solid rgb(var(--primary-color));
}
.o-search {
  border-radius: 999999px;
  padding-left: 20px;
}

@container (max-height: 600px) {
  .o-answers {
    height: 600px;
    min-height: unset;
    max-height: unset;
  }
}
</style>
